<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.kname" @click="Search" placeholder="名称"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addNet">增加</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <el-table-column label="配网名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="EditNet(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="DeleteNet(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title + '配网'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="配网名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="配网code" prop="code" label-width="100px">
          <el-input :disabled="edit" v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="Validate(Addconfirm)">{{edit?'修改':'新增'}}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        kname: '',
      },
      list: [],
      total: 0,
      title: '',
      edit: false,
      dialogFormVisible: false,
      form: {
        code: '',
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入配网名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入配网code', trigger: 'blur' }],
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search () {
      this.api.SetNetworkList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Addconfirm () {
      this.api.SetNetworkUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.Search()
          this.$message.success(this.title + '成功')
          this.dialogFormVisible = false
          return
        }
        this.$message.error(this.title + '失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    EditNet (item) {
      this.edit = true
      this.title = '编辑'
      this.api.SetNetworkDetail({
        code:  item.code
      }).then(res => {
        if (res.data.code == 200) {
          this.form = res.data.data
          this.dialogFormVisible = true
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    addNet () {
      this.edit = false
      this.title = '创建'
      this.form = {}
      this.dialogFormVisible = true
    },
    DeleteNet(item) {
      this.$confirm('是否删除该配网?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.SetNetworkDelete({code: item.code}).then(res => {
          if (res.data.code == 200) {
            this.$message({type: 'success',message: '删除成功!'});
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
  },
  filters: {},
  mounted () {
    this.Search()
  },
  created () {
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
